/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import * as styles from "./ModelApartment.module.css";
import dotsIcon from "../../../images/on-going-projects/enchanted/Icons/dots-icon.png";

function ModelApartment() {
  const [activeTab, setActiveTab] = useState("3BHK-Type-1");
  const _3bhkType1Video = "https://my.matterport.com/show/?m=HdSMgyhEVZE";
  const _3bhkType2Video = "https://my.matterport.com/show/?m=Ru72qMdaZLb";
  const _4bhkVideo = "https://my.matterport.com/show/?m=nxtjzW7PzuZ";

  const [videoUrl, setVideoUrl] = useState("");

  useEffect(() => {
    if (activeTab === "3BHK-Type-1") {
      setVideoUrl(_3bhkType1Video);
    } else if (activeTab === "3BHK-Type-2") {
      setVideoUrl(_3bhkType2Video);
    } else if (activeTab === "4BHK") {
      setVideoUrl(_4bhkVideo);
    }
  }, [activeTab]);

  return (
    <>
      <div className={styles.gallery} id="gallery">
        <div className={styles.galleryHeader}>
          <h1>
            <img loading="lazy"  src={dotsIcon} alt="dots-icon" className={styles.dotsIcon} />
            Model Apartment Walkthrough
          </h1>
          <div className={styles.tabs}>
            <button
              className={`${styles.tab} ${
                activeTab === "3BHK-Type-1" ? styles.active : ""
              }`}
              onClick={() => setActiveTab("3BHK-Type-1")}
            >
              3BHK Type-1 
            </button>
            <button
              className={`${styles.tab} ${
                activeTab === "3BHK-Type-2" ? styles.active : ""
              }`}
              onClick={() => setActiveTab("3BHK-Type-2")}
            >
              3BHK Type-2
            </button>
            <button
              className={`${styles.tab} ${
                activeTab === "4BHK" ? styles.active : ""
              }`}
              onClick={() => setActiveTab("4BHK")}
            >
              4BHK
            </button>
          </div>
        </div>

        <div className={styles.galleryGrid}>
          <iframe src={videoUrl} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen frameBorder="0" title="video" className="video-modal-iframe" />
        </div>
      </div>
    </>
  );
}

export default ModelApartment;
